import carsSuppliers from './../cars-suppliers';

export default function CarService() {
    return {
        getCarSupplierLogo,
        getCarImageUrl,
    };

    function getCarSupplierLogo(code) {
        return carsSuppliers[code]
            && carsSuppliers[code].logo;
    }

    function getCarImageUrl(car) {
        return car.CarImageUrl
            || carsSuppliers.unknown.logo;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/cars/services/car-service.js